/**
 * Admin Storage Keys Constants
 * Centralized storage keys to avoid magic strings.
 * Sprint B (Master Plan v5.1): all keys are tenant-scoped via StorageSlot
 * unless explicitly opted out via { tenantScope: 'global' }.
 */

// LocalStorage Keys
export const STORAGE_KEYS = {
  // Authentication
  AUTH_TOKEN: 'auth_token',

  // Form drafts
  BOUQUET_DRAFT: 'bouquet_draft',
  BOUQUET_COMPOSITION_DRAFT: 'bouquet_composition_draft',

  // UI state
  GROUPED_NAV: 'admin_grouped_nav_v1',
  EXPANDED_GROUPS: 'admin_expanded_groups_v1',
  ACCORDION_STATE: 'admin_accordion_state_v1',

  // Settings
  SAFE_SETTINGS_DRAFT: 'admin_safe_settings_draft_v1',

  // Analytics dashboard (read-only)
  ANALYTICS_DEVICE: 'admin_analytics_device_v1',
} as const

// SessionStorage Keys
export const SESSION_KEYS = {
  // Asset chunk reload guard
  CHUNK_RELOAD: 'admin_chunk_reload_v1',
} as const

// Browser environment check
export const isBrowser =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
